import { CodeItemWire } from '../types';
import { CodeItem } from '../types-store';
import { parseAsDateUTC } from 'app/infrastructure/data/date';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { Value } from 'app/types-shared';

//eslint:disable max-func-body-length
export const mapCodeToStore = (codeItemWire: CodeItemWire): CodeItem => {
  return {
    ...(!!codeItemWire.code && {
      id: codeItemWire.code.v,
      name: codeItemWire.code.d
    }),

    ...(!!codeItemWire.disabled && {
      disabled: parseAsDateUTC(codeItemWire.disabled)
    }),

    ...(!!codeItemWire.decimalColour && {
      colour: codeItemWire.decimalColour
    }),

    ...(!!codeItemWire.colourCode && {
      colourCode: {
        value: codeItemWire.colourCode.v,
        description: mapToEmptyStringIfZero(codeItemWire.colourCode),
        backgroundColor: codeItemWire.colourCode.decimalColour
      }
    }),

    ...(!!codeItemWire.icon && {
      icon: codeItemWire.icon
    }),

    ...(!!codeItemWire.icon2 && {
      residualIcon: codeItemWire.icon2
    }),

    ...(!!codeItemWire.category && {
      category: {
        value: codeItemWire.category.v,
        description: codeItemWire.category.d,
        ...(!!codeItemWire.category?.disabled) && {
          disabled: parseAsDateUTC(codeItemWire.category.disabled)
        }
      }
    }),

    ...(isDefinedIncludingZero(codeItemWire.sequence) && {
      sequence: codeItemWire.sequence
    }),

    ...(!!codeItemWire.language && {

      description: codeItemWire.language.map(language => ({
        value: language.v,
        description: language.d
      })),

      longDescription: codeItemWire.language.map(language => ({
        value: language.v,
        description: language.ld
      }))
    }),

    ...(!!codeItemWire.subset && {
      userGroups: codeItemWire.subset.map(subset => ({
        value: subset.v,
        description: subset.d,
        ...(subset.readOnly && { readOnly: subset.readOnly })
      }))
    }),

    ...(!!codeItemWire.exclude && {
      excludeFields: codeItemWire.exclude.map(exclude => ({
        value: exclude.v,
        description: exclude.d
      }))
    }),

    ...(!!codeItemWire.application && {
      caseTypes: codeItemWire.application.map(application => ({
        value: application.v,
        description: application.d
      }))
    }),

    ...(!!codeItemWire.class && {
      codetableTypes: codeItemWire.class.map(classItem => ({
        value: classItem.v,
        description: classItem.d
      }))
    }),

    ...(!!codeItemWire.parent && {
      parent: {
        value: codeItemWire.parent.v,
        description: codeItemWire.parent.d,
        disabled: parseAsDateUTC(codeItemWire.parent.disabled)
      }
    }),

    ...(!!codeItemWire.node && {
      node: {
        value: codeItemWire.node.v,
        description: codeItemWire.node.d,
        longDescription: codeItemWire.node?.ld,
        disabled: parseAsDateUTC(codeItemWire.node.disabled)
      }
    }),

    ...(codeItemWire.companyRegisterId !== undefined && {
      companyRegisterId: codeItemWire.companyRegisterId
    }),

    ...(isDefinedIncludingZero(codeItemWire.scoreCalcWeight) && {
      scoreCalcWeight: codeItemWire.scoreCalcWeight
    }),

    ...(!!codeItemWire.severity && {
      severity: {
        value: codeItemWire.severity.v,
        description: mapToEmptyStringIfZero(codeItemWire.severity)
      }
    }),

    ...(!!codeItemWire.uom && {
      uom: {
        value: codeItemWire.uom.v,
        description: mapToEmptyStringIfZero(codeItemWire.uom),
        disabled: parseAsDateUTC(codeItemWire.uom.disabled)
      }
    }),

    ...(isDefinedIncludingZero(codeItemWire.low) && {
      low: codeItemWire.low
    }),

    ...(isDefinedIncludingZero(codeItemWire.mid) && {
      mid: codeItemWire.mid
    }),

    ...(isDefinedIncludingZero(codeItemWire.high) && {
      high: codeItemWire.high
    }),

    ...(!!codeItemWire.recurrence && {
      recurrence: {
        value: codeItemWire.recurrence.v,
        description: mapToEmptyStringIfZero(codeItemWire.recurrence)
      }
    }),

    ...(!!codeItemWire.likelihood && {
      likelihood: {
        value: codeItemWire.likelihood.v,
        description: mapToEmptyStringIfZero(codeItemWire.likelihood)
      }
    }),

    ...(isDefinedIncludingZero(codeItemWire.minLevel) && {
      minLevel: codeItemWire.minLevel
    }),

    ...(isDefinedIncludingZero(codeItemWire.level) && {
      level: codeItemWire.level
    }),

    ...(!!codeItemWire.checkedCode && {
      checkedCode: {
        value: codeItemWire.checkedCode.v,
        description: codeItemWire.checkedCode.d,
        disabled: parseAsDateUTC(codeItemWire.checkedCode.disabled)
      }
    }),

    ...(!!codeItemWire.uncheckedCode && {
      uncheckedCode: {
        value: codeItemWire.uncheckedCode.v,
        description: codeItemWire.uncheckedCode.d,
        disabled: parseAsDateUTC(codeItemWire.uncheckedCode.disabled)
      }
    }),

    ...(isDefinedIncludingZero(codeItemWire.rangeFrom) && {
      rangeFrom: codeItemWire.rangeFrom
    }),

    ...(isDefinedIncludingZero(codeItemWire.rangeTo) && {
      rangeTo: codeItemWire.rangeTo
    }),

    ...(!!codeItemWire.defaultUom && {
      defaultUom: {
        value: codeItemWire.defaultUom.v,
        description: codeItemWire.defaultUom.d,
        disabled: parseAsDateUTC(codeItemWire.defaultUom.disabled)
      }
    }),

    ...(!!codeItemWire.defaultUomType && {
      defaultUomType: {
        value: codeItemWire.defaultUomType.v,
        description: codeItemWire.defaultUomType.d,
        disabled: parseAsDateUTC(codeItemWire.defaultUomType.disabled)
      }
    }),

    ...(!!codeItemWire.consequenceType && {
      consequenceType: {
        value: codeItemWire.consequenceType.v,
        description: mapToEmptyStringIfZero(codeItemWire.consequenceType),
        disabled: parseAsDateUTC(codeItemWire.consequenceType.disabled)
      }
    }),

    ...(!!codeItemWire.uomTypeFrom && {
      uomTypeFrom: {
        value: codeItemWire.uomTypeFrom.v,
        description: mapToEmptyStringIfZero(codeItemWire.uomTypeFrom),
        disabled: parseAsDateUTC(codeItemWire.uomTypeFrom.disabled)
      }
    }),

    ...(!!codeItemWire.uomTypeTo && {
      uomTypeTo: {
        value: codeItemWire.uomTypeTo.v,
        description: mapToEmptyStringIfZero(codeItemWire.uomTypeTo),
        disabled: parseAsDateUTC(codeItemWire.uomTypeTo.disabled)
      }
    }),

    ...(!!codeItemWire.substanceUomSet && {
      substanceUomSet: codeItemWire.substanceUomSet.map(substanceUomSet => ({
        uomSet: {
          value: substanceUomSet.uomSet.v,
          description: substanceUomSet.uomSet.d
        },
        ...(substanceUomSet?.uom?.v && {
          uom: {
            value: substanceUomSet.uom.v,
            description: substanceUomSet.uom.d,
            disabled: parseAsDateUTC(substanceUomSet.uom.disabled),
            ...(substanceUomSet.uom.ld && { longDescription: substanceUomSet.uom.ld })
          }
        }),
        ...(substanceUomSet?.uomType?.v && {
          uomType: {
            value: substanceUomSet.uomType.v,
            description: substanceUomSet.uomType.d,
            ...(substanceUomSet.uomType.ld && { longDescription: substanceUomSet.uomType.ld })
          }
        }),
        ...(substanceUomSet?.uomIndicator?.v && {
          uomIndicator: {
            value: substanceUomSet.uomIndicator.v,
            description: mapToEmptyStringIfZero(substanceUomSet.uomIndicator),
            disabled: parseAsDateUTC(substanceUomSet.uomIndicator.disabled),
            ...(substanceUomSet.uomIndicator.ld && { longDescription: substanceUomSet.uomIndicator.ld })
          }
        }),
        ...(substanceUomSet?.uomTypeIndicator?.v && {
          uomTypeIndicator: {
            value: substanceUomSet.uomTypeIndicator.v,
            description: mapToEmptyStringIfZero(substanceUomSet.uomTypeIndicator),
            ...(substanceUomSet.uomTypeIndicator.ld && { longDescription: substanceUomSet.uomTypeIndicator.ld })
          }
        })
      })),

      ...(!!codeItemWire.substanceConversionFactor && {
        substanceConversionFactor: codeItemWire.substanceConversionFactor.map(conversionFactor => ({
          uomConversionType: {
            value: conversionFactor.uomConversionType.v,
            description: conversionFactor.uomConversionType.d
          },
          uomTypeFrom: {
            value: conversionFactor.uomTypeFrom.v,
            description: conversionFactor.uomTypeFrom.d,
            disabled: parseAsDateUTC(conversionFactor.uomTypeFrom.disabled)
          },
          uomFrom: {
            value: conversionFactor.uomFrom.v,
            description: conversionFactor.uomFrom.d,
            disabled: parseAsDateUTC(conversionFactor.uomFrom.disabled),
            ...(conversionFactor.uomFrom.ld && { longDescription: conversionFactor.uomFrom.ld })
          },
          uomTypeTo: {
            value: conversionFactor.uomTypeTo.v,
            description: conversionFactor.uomTypeTo.d,
            disabled: parseAsDateUTC(conversionFactor.uomTypeTo.disabled)
          },
          uomTo: {
            value: conversionFactor.uomTo.v,
            description: conversionFactor.uomTo.d,
            disabled: parseAsDateUTC(conversionFactor.uomTo.disabled),
            ...(conversionFactor.uomTo.ld && { longDescription: conversionFactor.uomTo.ld })
          },
          ...(isDefinedIncludingZero(conversionFactor.factor) && { factor: conversionFactor.factor })
        }))
      })
    }),

    ...(!!codeItemWire?.measurementSystem?.v && {
      measurementSystem: {
        value: codeItemWire.measurementSystem.v,
        description: codeItemWire.measurementSystem.d ?? ''
      }
    }),

    ...(!!codeItemWire.uomConversion && {
      uomConversion: codeItemWire.uomConversion.map(uomConversion => {
        return {
          value: uomConversion.uomTo.v,
          description: uomConversion.uomTo.d,
          ...(uomConversion.uomTo.ld && { longDescription: uomConversion.uomTo.ld }),
          factor: uomConversion.factor
        };
      })
    })
  };
};

export const mapToEmptyStringIfZero = (value: Value) => (value?.v === 0 ? '' : value?.d);
